import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GenerateTtsRequest, TtsResponse } from '../models/tts.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class TtsService {

	constructor(private http: HttpClient) {}

	generateSpeech(request: GenerateTtsRequest): Observable<TtsResponse> {
		const trimmed = request.text?.trim();
		if (!trimmed) {
			return of({ publicUrl: '', audioId: '', provider: 'google' });
		}

		const body: Record<string, unknown> = {
			text: trimmed,
			speaker: request.speaker,
			provider: request.provider ?? 'google',
		};

		if (request.override) {
			body['override'] = true;
		}

		return this.http.post<TtsResponse>(
			`${environment.SERVICES.CONTENT}v1/tts`,
			body,
		);
	}
}
